module.exports = __webpack_public_path__ + "img/banner.05f96380.jpg";